import React from 'react';
import CurrencyTextField from '@unicef/material-ui-currency-textfield';
import { get } from 'lodash';
import { GenericFormFields } from '../interfaces';

const FormCurrencyField: React.FC<GenericFormFields> = ({
  fields,
  item,
  values,
  setFieldValue,
  changeField,
  errors,
}) => {
  return (
    <CurrencyTextField
      key={item.stateKey}
      name={item.stateKey}
      value={
        fields ? get(fields, item.stateKey, '') : get(values, item.stateKey, '')
      }
      margin="none"
      label={item.label}
      variant="outlined"
      onChange={(e: React.ChangeEvent<HTMLInputElement>, val: number) => {
        if (setFieldValue) setFieldValue(item.stateKey, val);
        if (changeField) changeField({ key: item.stateKey, value: val });
      }}
      currencySymbol="R$"
      outputFormat="number"
      decimalCharacter=","
      digitGroupSeparator="."
      fullWidth
      disabled={item.disabled}
      error={
        !!get(errors, item.stateKey, null) || !!get(errors, item.error, null)
      }
      helperText={
        get(errors, item.stateKey, null) || get(errors, item.error, null)
      }
    />
  );
};

export default FormCurrencyField;
